import { useSession } from "@otto/plattform";
import { InviteForm } from "./InviteForm.js";
import { LicenseCard } from "./LicenseCard.js";
import { TeacherTable } from "./TeacherTable.js";
import { useInviteTeacher, useSchool, useTeachers } from "../lib/data.js";

export function School() {
  const { client, state } = useSession();
  const profile = state.kind === "signedIn" ? state.identity.profile : null;
  const schoolId = profile?.schoolId ?? "";

  const school = useSchool(client, schoolId);
  const teachers = useTeachers(client, schoolId);
  const invite = useInviteTeacher(client, schoolId);

  return (
    <>
      <LicenseCard
        schoolName={school.data?.name ?? "Schule"}
        licenseUntil={school.data?.license_until ?? null}
      />
      {teachers.data && <TeacherTable teachers={teachers.data} />}
      <InviteForm
        pending={invite.isPending}
        succeeded={invite.isSuccess}
        errorCode={invite.isError ? invite.error.message : null}
        errorStatus={
          invite.isError ? (invite.error as { status?: number }).status : undefined
        }
        onInvite={(input) => invite.mutate(input, { onSuccess: () => undefined })}
      />
    </>
  );
}
